import styled, { css } from 'styled-components';

import Tooltip from '../tooltip';

import ICoresData from '../../context/ICoresData';

interface CoresProps {
  cores: ICoresData;
}

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  cores: ICoresData;
}

export const Container = styled.div<ContainerProps>`

  background: #FFF;
  border-radius: 10px;
  padding: 16px;
  width: 100%;

  display: flex;
  align-items: center;

  border: 2px solid ${props => props.cores.secundaria};
  color: lightgray;

  & + div {
      margin-top: 8px;
  }

  ${props => props.isErrored && css`
    border-color: #C53030;
  `}

  /* Se foco está no componente troca cor e borda */
  ${props => props.isFocused && css`
    color: ${props.cores.secundariaShade};
    border-color: ${props.cores.secundariaShade};
  `}

  /* Se componente foi preenchido troca cor */
  ${props => props.isFilled && css`
    color: ${props.cores.texto};
  `}

  input {
    background: transparent;

    /* ocupa todo o espaço possível: */
    flex: 1;

    border: 0;
    color: ${props => props.cores.texto};

    &::placeholder {
        color: lightgray;
    }
  }

  /* pega o primeiro ícone dentro do container: */
  > svg {
    margin-right: 16px;
  }
`;

// estilizando um outro componente dentro do componente pai
export const Error = styled(Tooltip)<CoresProps>`
  /* pra não mexer no tamanho do input: */
  height: 20px;

  /* texto do input manter distância do ícone: */
  margin-left: 16px;

  /* pra não ficar margem a direita do ícone: */
  svg {
    margin: 0;
  }

  /* estilização do tooltip pra deixar vermelho no caso de erro que é o container atual: */
  span {
    background: #c53030;
    color: #FFF;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
